import { createMemoryHistory } from 'history';
import { RouteChildrenProps } from 'react-router';

export const routePropsMock: RouteChildrenProps = {
  history: createMemoryHistory(),
  location: {
    pathname: '',
    search: '',
    state: '',
    hash: '',
  },
  match: {
    isExact: true,
    params: {},
    url: '/',
    path: '/',
  },
};
